<template lang="pug">
  v-btn.mr-2(
    @click="$router.go(-1)"
    color="primary"
    depressed
    v-bind="$attrs"
  )
    v-icon(left) mdi-chevron-left
    | Назад

</template>

<script>
export default {
  name: 'BackButton',
};
</script>

<style lang="scss" scoped>

</style>
